import styled from '@emotion/styled';

import { hoverable } from '../../interaction-states';
import { IconButton } from '../Button';

export const StyledExpandToggle = styled(IconButton)(({ theme }) => ({
  ...hoverable(theme, 'surface'),
  padding: 8,
  color: theme.colors.icon.secondary,
  flexShrink: 0,
  cursor: 'pointer',
  userSelect: 'none',

  '&:hover, &:active': {
    textDecoration: 'none',
  },

  '*': {
    cursor: 'inherit',
  },

  svg: {
    transition: 'transform 0.2s ease',
    pointerEvents: 'none',
  },
}));
